var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page-container flex-mid"},[_c('login',{attrs:{"env":_vm.env,"placeholder":"请输入手机号"},on:{"login":_vm.login}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }